import React, { useState, useEffect } from 'react';
import image7 from "../images/image7.jpg";
import image8 from "../images/image8.jpg";
import image9 from "../images/image9.jpg";
import { Helmet } from 'react-helmet';
import '../static/App.css';
import { Bento, Accessibility, Iron, Bathtub, SelfImprovement, LocalMall, Medication, Schedule, Psychology, ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import { Button, Grid, Card, CardContent, Typography, Box, useTheme, useMediaQuery, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';

const Services = () => {
    const [activeCard, setActiveCard] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const services = [
        {
        image: image7,
        title: '24-HOUR LIVE-IN CARE',
        description:
            'Our caregivers provide around-the-clock care and support, living with your loved one in their home. This comprehensive service includes assistance with daily living activities, medication management, meal preparation, light housekeeping, and continuous supervision. Ideal for those who need constant care or prefer the comfort of having a caregiver present at all times.',
        benefits: [
            'Continuous supervision',
            'Medication management',
            'Meal preparation',
            'Overnight care',
            'Personal care assistance',
        ],
        },
        {
        image: image8,
        title: 'DAILY LIVING ACTIVITY SUPPORT',
        description:
            'Our professional caregivers assist with daily activities while encouraging independence and preserving dignity. We provide just the right amount of support to help your loved one maintain their routine and quality of life with minimal interference.',
        benefits: [
            'Personal care assistance',
            'Mobility support',
            'Meal preparation',
            'Medication reminders',
            'Routine maintenance',
        ],
        },
        {
        image: image9,
        title: 'COMPANIONSHIP & SUPERVISION',
        description:
            'Our caregivers provide meaningful companionship and vigilant supervision to keep your loved one socially engaged, mentally stimulated, and safe. We accompany clients to appointments, events, and activities, ensuring they remain connected to their community.',
        benefits: [
            'Social engagement',
            'Safety supervision',
            'Transportation assistance',
            'Cognitive stimulation',
            'Activity participation',
        ],
        },
    ];

    const otherServices = [
        {
        icon: Bento,
        title: 'MEAL PREPARATION',
        description:
            "Our caregivers prepare nutritious, delicious meals tailored to your loved one's dietary needs, preferences, and any medical requirements.",
        },
        {
        icon: LocalMall,
        title: 'SHOPPING & ERRANDS',
        description:
            'We assist with grocery shopping, prescription pickups, post office visits, and other essential errands to make life easier.',
        },
        {
        icon: SelfImprovement,
        title: 'EXERCISE & MOBILITY',
        description:
            'Gentle exercise programs and mobility assistance tailored to individual abilities and health conditions.',
        },
        {
        icon: Medication,
        title: 'MEDICATION MANAGEMENT',
        description:
            'Comprehensive medication reminders and management to ensure medications are taken correctly and on time.',
        },
        {
        icon: Accessibility,
        title: 'TRANSFER & AMBULATION',
        description:
            'Safe assistance with lifting, transferring, and ambulation to prevent falls and maintain mobility.',
        },
        {
        icon: Iron,
        title: 'LIGHT HOUSEKEEPING',
        description:
            'Light cleaning, laundry, and home organization to maintain a comfortable and safe living environment.',
        },
        {
        icon: Bathtub,
        title: 'PERSONAL CARE',
        description:
            'Discreet and respectful assistance with bathing, grooming, dressing, and personal hygiene.',
        },
        {
        icon: Schedule,
        title: 'RESPITE CARE',
        description:
            'Temporary relief for family caregivers, providing peace of mind knowing your loved one is in professional hands.',
        },
        {
        icon: Psychology,
        title: 'COGNITIVE SUPPORT',
        description:
            'Activities and exercises designed to support cognitive function and mental stimulation.',
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
        setFade(false);
        setTimeout(() => {
            setCurrentIndex((prev) => (prev + 1) % services.length);
            setFade(true);
        }, 800);
        }, 20000);

        return () => clearInterval(interval);
    }, [services.length]);

    const handleCardClick = (i) => {
        setActiveCard(activeCard === i ? null : i);
    };

    const handleManualCarouselChange = (i) => {
        setFade(false);
        setTimeout(() => {
        setCurrentIndex(i);
        setFade(true);
        }, 300);
    };

    return (
        <div className='page-back'>
            <div className="container" style={{ borderRadius:10, padding: '1rem' }}>
                <Helmet>
                    <title>24/7 AssureCare - Comprehensive Care Services</title>
                    <meta name="description" content="Discover 24/7 AssureCare's comprehensive home care services including live-in care, daily living assistance, companionship, meal prep, medication management, and more."/>
                    <meta name="keywords" content="home care services, elderly care, companion care, live-in care, daily living assistance, medication management, respite care"/>
                </Helmet>

                {/* Header */}
                <Box sx={{ textAlign:'center', mb:4 }}>
                    <Typography variant="h2" component="h1" sx={{ color:'rgba(255, 255, 255, 1)', fontWeight:'bold', mb:2, fontSize:isMobile?'2rem':'2.5rem' }}>OUR COMPREHENSIVE SERVICES</Typography>
                    <Typography variant="h6" sx={{ color:'white', maxWidth:800, m:'0 auto' }}>Providing exceptional quality care in Cook, DuPage, and Lake counties — and expanding!</Typography>
                    {/* <Typography variant="body2" sx={{ color:'white', fontStyle:'italic', mt:1 }}>(If you're outside these areas, contact us — we may still be able to help!)</Typography> */}
                </Box>

                {/* Carousel */}
                <Card sx={{ mb:6, borderRadius:3, boxShadow:3, overflow:'hidden' }}>
                    <Grid sx={{ minHeight: '600px'}} container>
                        
                        {/* Image with arrows + dots */}
                        <Grid item xs={12} md={6} sx={{ position:'relative', minHeight:isMobile?300:400 }}>
                            <Box sx={{ width:'100%', height:'100%', position:'relative', overflow:'hidden' }}>
                                {services.map((s,i)=>(
                                <Box key={i} component="img" src={s.image} alt={s.title} sx={{ width:'100%', height:'100%', objectFit:'cover', position:'absolute', top:0, left:0, opacity:i===currentIndex&&fade?1:0, transition:'opacity 0.8s ease-in-out' }}/>
                                ))}
                            </Box>

                            {/* Left Arrow */}
                            <IconButton onClick={() => handleManualCarouselChange((currentIndex - 1 + services.length) % services.length)} sx={{ position:'absolute', top:'50%', left:10, transform:'translateY(-50%)', backgroundColor:'rgba(255,255,255,0.6)', '&:hover': { backgroundColor:'rgba(255,255,255,0.9)' }}}>
                                <ArrowBackIosNew />
                            </IconButton>

                            {/* Right Arrow */}
                            <IconButton onClick={() => handleManualCarouselChange((currentIndex + 1) % services.length)}
                                sx={{ position:'absolute', top:'50%', right:10, transform:'translateY(-50%)', backgroundColor:'rgba(255,255,255,0.6)',
                                '&:hover': { backgroundColor:'rgba(255,255,255,0.9)' }}}>
                                <ArrowForwardIos />
                            </IconButton>

                            {/* Dots */}
                            <Box sx={{ position:'absolute', bottom:16, left:'50%', transform:'translateX(-50%)', display:'flex', gap:1 }}>
                                {services.map((_,i)=>(
                                <Box key={i} onClick={()=>handleManualCarouselChange(i)} sx={{ width:12, height:12, borderRadius:'50%',
                                    backgroundColor:i===currentIndex?'primary.main':'grey.300',
                                    cursor:'pointer', transition:'background-color 0.3s', '&:hover':{backgroundColor:i===currentIndex?'primary.dark':'grey.400'}}}/>
                                ))}
                            </Box>
                        </Grid>
                        {/* Text side */}
                        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3, height: '100%',}}>
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="h5" gutterBottom sx={{ color: '#1b8fc9', fontWeight: 'bold' }}>
                                {services[currentIndex].title}
                                </Typography>
                                <Typography variant="body1" sx={{ fontSize: '1.1rem', color: 'text.primary', mb: 2, lineHeight: 1.6 }}>
                                {services[currentIndex].description}
                                </Typography>
                            </Box>

                            <Box sx={{ mt: 2 }}>
                                <Typography variant="h6" sx={{ mb: 1, color: '#1b8fc9', fontWeight: 'bold' }}>
                                Service Includes:
                                </Typography>
                                <Box component="ul" sx={{ pl: 3, m: 0 }}>
                                {services[currentIndex].benefits.map((b, j) => (
                                    <Typography key={j} component="li" variant="body2" sx={{ mb: 0.5, color: 'text.secondary', fontSize: '1rem', lineHeight: 1.5 }}>
                                    {b}
                                    </Typography>
                                ))}
                                </Box>
                            </Box>
                            </Grid>
                        </Grid>
                    </Card>

                {/* Additional Services */}
                <Box sx={{ mb:6 }}>
                    <Typography variant="h3" component="h2" sx={{ textAlign:'center', mb:4, color:'rgba(255, 255, 255, 1)', fontWeight:'bold' }}>Our Additional Services</Typography>
                    <Grid container spacing={3}>
                        {otherServices.map((s,i)=>{ const Icon=s.icon; const isActive=activeCard===i;
                        return (
                            <Grid item xs={12} sm={6} md={4} key={i}>
                                <Card onClick={()=>handleCardClick(i)} sx={{ height:'100%', cursor:'pointer', transition:'all 0.3s ease', transform:isActive?'scale(1.02)':'scale(1)', boxShadow:isActive?3:1, border:isActive?`2px solid ${theme.palette.primary.main}`:'2px solid transparent', '&:hover':{ boxShadow:3, transform:'translateY(-4px)' }}}>
                                    <CardContent sx={{ textAlign:'center', p:3, display:'flex', flexDirection:'column', alignItems:'center', height:'100%' }}>
                                        <Icon sx={{ fontSize:60, mb:2, color:'#1b8fc9' }}/>
                                        <Typography variant="h6" component="h3" sx={{ mb:2, fontWeight:'bold', color:'#1b8fc9' }}>{s.title}</Typography>
                                        <Typography variant="body2" sx={{ opacity:isActive?1:0, maxHeight:isActive?200:0, overflow:'hidden', transition:'all 0.3s ease', flexGrow:1 }}>{s.description}</Typography>
                                        <Typography variant="caption" sx={{ color:'primary.main', mt:1, fontStyle:'italic', opacity:isActive?0:1, transition:'opacity 0.3s ease' }}>Click to learn more</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                        })}
                    </Grid>
                </Box>

                {/* CTA */}
                <Box sx={{ backgroundColor:'rgba(21,149,160,0.1)', borderRadius:3, p:4, textAlign:'center', mb:4, boxShadow:3 }}>
                    <Typography variant="h4" component="h2" sx={{ mb:2, color:'rgba(0, 0, 0, 1)' }}>Ready to Discuss Your Care Needs?</Typography>
                    <Typography variant="body1" sx={{ mb:3, maxWidth:600, m:'0 auto' }}>Our care coordinators are ready to help you create a personalized care plan that meets your specific needs and preferences.</Typography>
                    <Button className='mt-2' component={Link} to="/contact" variant="contained" size="large" sx={{ backgroundColor:'#1b8fc9','&:hover':{color: 'white', backgroundColor:'#156a9e'}, px:4, py:1.5 }}>Schedule a Free Consultation</Button>
                </Box>
            </div>
        </div>
    );
};

export default Services;
